import React, { useState, useEffect } from "react";
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,   

  Line,
  ComposedChart,
} from "recharts";   


const monthMap = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec",
};

const VCByMonth = () => {
  const [chartData, setChartData] = useState([]);
  const [maxValue, setMaxValue] = useState(0);
  const COLORS = ["#0088FE", "#FF0000", "#008000", "#FFBB28", "#00C49F"];

  useEffect(() => {
    fetch("https://malaria-api.ddc-malaria.org/mhealth/getChartOverallVCToday/fs_year")
      .then((response) => response.json())
      .then((data) => {
        let newMaxValue = 0; // Initialize a variable to track the max value

        const transformedData = Object.entries(
          data.overall_vc_status_by_month_fiscal
        ).map(([monthKey, monthData]) => {
          const { year_month, total_vc_detail } = monthData;
          const monthYear = monthMap[year_month.slice(4)];

          const {
            llin_paid,
            llihn_paid,
            net_paid,
            itn_paid,
            mosq_repellent_paid,
          } = total_vc_detail;

          const totalAll =
            parseInt(llin_paid, 10) +
            parseInt(llihn_paid, 10) +
            parseInt(net_paid, 10) +
            parseInt(itn_paid, 10) +
            parseInt(mosq_repellent_paid, 10);

          newMaxValue = Math.max(newMaxValue, totalAll); // Update newMaxValue

          return {
            month: monthYear,
            Total: totalAll,
            LLINs: parseInt(llin_paid, 10),
            LLIHNs: parseInt(llihn_paid, 10),
            Repellent: parseInt(mosq_repellent_paid, 10),
            Net: parseInt(net_paid, 10),
            ITNs: parseInt(itn_paid, 10),
          };
        });

        setChartData(transformedData);
        setMaxValue(newMaxValue); // Update maxValue after calculating it
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []); 

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
          // Filter payload to only include Bar data
          const barPayload = payload.filter((item) => item.dataKey !== "Total");
    
          return (
            <div className="custom-tooltip">
              <p className="label">{label}</p>
              {barPayload.map((item, index) => (
                <p key={index} className="intro" style={{ color: item.color, fontSize: '14px' }}> {/* Set color and font size */}
                  {item.name}: {item.value}
                </p>
              ))}
            </div>
          );
        }
    
        return null;
      };

    return (
        <div className="plan-status-by-month">
            <h3>Overall Commodities by Month</h3>
            <ResponsiveContainer width="100%" height={300}>
                <ComposedChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                    <YAxis domain={[0, maxValue * 1.2]} tick={{ fontSize: 12 }} />
                    <Tooltip content={<CustomTooltip />}  />
                    <Legend />
                    <Bar dataKey="LLINs" stackId="a" fill={COLORS[0]} color={COLORS[0]} />
                    <Bar dataKey="LLIHNs" stackId="a" ffill={COLORS[1]} color={COLORS[1]}  />
                    <Bar dataKey="Repellent" stackId="a" fill={COLORS[2]} color={COLORS[2]}  />
                    <Bar dataKey="Net" stackId="a" fill={COLORS[3]} color={COLORS[3]}  />
                    <Bar dataKey="ITNs" stackId="a" fill={COLORS[4]} color={COLORS[4]}  />
                    <Line
                        type="monotone"
                        dataKey="Total"
                        stroke="#3f51b5"
                        strokeWidth={0}
                        dot={false}
                        label={{ position: 'top' , fontSize: 12,formatter: (value) => `${value}`,fontWeight: 'bold'}} 
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
};

export default VCByMonth;

